import { FormControl, FormGroup, HelpBlock, InputGroup } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';
import Text from '../../../generic/Text';
import { window } from '../../../../globals';
import { formatSubdomainToFullURL } from '../../../../helpers/url';
import Link from '../../../generic/Link';
import { isValidSubdomain } from './utils';
import { useAuthenticationSettingsContext } from './hooks';

const LoginSubdomain: VoidFunctionComponent = () => {
  const { settings, onUpdateSettings } = useAuthenticationSettingsContext();

  const validateSubdomain = (): 'error' | null => {
    const { subdomain } = settings;

    // Don't show an error if they haven't set a subdomain
    if (!subdomain) {
      return null;
    }

    if (['admin', 'administrator', 'fossa', 'login'].includes(subdomain) || !isValidSubdomain(subdomain)) {
      return 'error';
    }

    return null;
  };

  return (
    <>
      <Text.H3>Login subdomain</Text.H3>
      <div className="gray-rounded-box">
        <FormGroup validationState={validateSubdomain()} className="nomargin">
          <InputGroup>
            <FormControl
              type="text"
              name="subdomain"
              value={settings.subdomain || ''}
              placeholder="company-name"
              onChange={(event) => onUpdateSettings({ subdomain: (event.target as HTMLTextAreaElement).value })}
              style={{ border: 'solid 1px #ccc' }}
            />
            <InputGroup.Addon>.{window.customerDomain}</InputGroup.Addon>
          </InputGroup>
          <HelpBlock className="margin-bottom-none">
            Members of your company can go to{' '}
            {settings.subdomain ? (
              <Link to={formatSubdomainToFullURL(settings.subdomain as string)} openInNewTab>
                {formatSubdomainToFullURL(settings.subdomain as string)}
              </Link>
            ) : (
              'the subdomain you choose'
            )}{' '}
            to log into your organization using SAML or LDAP. The subdomain should only contain letters, numbers, and the symbol{' '}
            <code>-</code> (except at the ends).
          </HelpBlock>
        </FormGroup>
      </div>
    </>
  );
};

export default LoginSubdomain;
